import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import "./tooltip.css";

interface TooltipProps {
  title: string;
  content: string;
  offsetY?: number;
}

const Tooltip: React.FC<TooltipProps> = ({ title, content, offsetY = -3 }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const [placement, setPlacement] = useState<"right" | "bottom">("right");
  const triggerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isVisible && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      const tooltipWidth = 280;
      const spaceOnRight = window.innerWidth - rect.right;

      if (spaceOnRight >= tooltipWidth + 20) {
        setPlacement("right");
        setPosition({
          top: rect.top + window.scrollY,
          left: rect.right + 8,
        });
      } else {
        setPlacement("bottom");
        setPosition({
          top: rect.bottom + window.scrollY + 25,
          left:
            rect.left + window.scrollX + rect.width / 2 - tooltipWidth / 2 - 20,
        });
      }
    }
  }, [isVisible]);

  const tooltipPortal = isVisible
    ? createPortal(
        <div
          className={`tooltip-popup tooltip-portal tooltip-portal--${placement}`}
          style={{
            position: "absolute",
            top: `${position.top}px`,
            left: `${position.left}px`,
            transform: placement === "right" ? "translateY(-50%)" : "none",
          }}
        >
          <div className={`tooltip-arrow tooltip-arrow--${placement}`}></div>
          <div className="tooltip-content">
            <h4 className="tooltip-title">{title}</h4>
            <p className="tooltip-text">{content}</p>
          </div>
        </div>,
        document.body
      )
    : null;

  return (
    <>
      <div
        className="tooltip-container"
        style={{
          transform: `translateY(${offsetY}px)`,
        }}
      >
        <div
          ref={triggerRef}
          className="tooltip-trigger"
          onMouseEnter={() => setIsVisible(true)}
          onMouseLeave={() => setIsVisible(false)}
        >
          <span className="tooltip-icon">i</span>
        </div>
      </div>
      {tooltipPortal}
    </>
  );
};

export default Tooltip;
